import {
  ProjectSummaryItem,
  ProjectSummaryItemContent,
  ProjectSummaryValue,
  ProjectSummaryLabel
} from '../../styled-components'

const HeaderSummaryItem = ({
  Icon = null,
  label = null,
  value = null,
  ...props
}) => {
  return (
    <ProjectSummaryItem {...props}>
      {Icon}
      <ProjectSummaryItemContent>
        <ProjectSummaryValue>{value}</ProjectSummaryValue>
        <ProjectSummaryLabel>{label}</ProjectSummaryLabel>
      </ProjectSummaryItemContent>
    </ProjectSummaryItem>
  )
}

export default HeaderSummaryItem
